<template>
  <div class="fa-picker">
    <div class="d-flex flex-wrap align-items-center" style="gap: 8px">
      <input
        v-model="query"
        type="text"
        class="form-control form-control-sm fa-picker__search"
        :placeholder="$t('faIconPicker.placeholder')"
        :aria-label="$t('faIconPicker.placeholder')"
      >
      <div class="btn-group btn-group-sm" role="group" :aria-label="$t('faIconPicker.styleLabel')">
        <button
          v-for="s in STYLES"
          :key="s.key"
          type="button"
          class="btn"
          :class="style === s.key ? 'btn-primary' : 'btn-outline-primary'"
          @click="style = s.key"
        >
          {{ $t(`faIconPicker.styles.${s.key}`) }}
        </button>
      </div>
    </div>

    <div v-if="loadFailed" class="text-danger small mt-2">{{ $t('faIconPicker.loadFailed') }}</div>

    <div v-else-if="!query.trim()" class="mt-2 d-flex flex-wrap align-items-center" style="gap: 6px">
      <small class="text-muted">{{ $t('faIconPicker.suggestions') }}</small>
      <button
        v-for="word in SUGGESTIONS"
        :key="word"
        type="button"
        class="btn btn-sm btn-outline-secondary py-0"
        @click="query = word"
      >
        {{ word }}
      </button>
    </div>

    <div v-else-if="!results.length" class="text-muted small mt-2">
      {{ loading ? $t('faIconPicker.loading') : $t('faIconPicker.empty') }}
    </div>

    <div v-else class="fa-picker__grid mt-2">
      <button
        v-for="row in results"
        :key="row[0]"
        type="button"
        class="fa-picker__item"
        :class="{ 'fa-picker__item--active': value === classOf(row) }"
        :title="row[1]"
        :aria-label="row[1]"
        @click="$emit('select', classOf(row))"
      >
        <i :class="classOf(row)" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script>
import { searchIcons, iconClass } from '../utils/faIconSearch'

const STYLES = [
  { key: 'solid', cls: 'fa-solid', code: 's' },
  { key: 'regular', cls: 'fa-regular', code: 'r' },
  { key: 'light', cls: 'fa-light', code: 'l' },
]

const SUGGESTIONS = ['pessoa', 'veículo', 'imóvel', 'celular', 'arma', 'objeto', 'ambulância']

export default {
  name: 'FaIconPicker',

  props: {
    // classe do ícone escolhido hoje (ex.: "fa-solid fa-car"), só para destacar na grade
    value: { type: String, default: null },
  },

  data() {
    return {
      STYLES,
      SUGGESTIONS,
      query: '',
      style: 'solid',
      catalog: null,
      loading: false,
      loadFailed: false,
    }
  },

  computed: {
    styleDef() {
      return STYLES.find(s => s.key === this.style)
    },
    // Só mostra os ícones que existem no estilo escolhido (nem todo ícone tem versão leve).
    results() {
      if (!this.catalog) return []

      return searchIcons(this.catalog, this.query, 200)
        .filter(row => row[3].includes(this.styleDef.code))
        .slice(0, 60)
    },
  },

  watch: {
    query(v) {
      if (v.trim() && !this.catalog) this.loadCatalog()
    },
  },

  methods: {
    classOf(row) {
      return iconClass(this.styleDef.cls, row[0])
    },

    // ~260 KB: só baixa quando alguém digita a primeira busca.
    async loadCatalog() {
      if (this.loading) return
      this.loading = true
      try {
        const mod = await import('../assets/auxiliary/fontawesome/metadata/catalog.json')
        this.catalog = mod.default || mod
      } catch (e) {
        this.loadFailed = true
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.fa-picker__search {
  max-width: 260px;
}

.fa-picker__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 220px;
  overflow-y: auto;
}

.fa-picker__item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  padding: 0;
  font-size: 18px;
  color: #5e5873;
  background: #fff;
  border: 1px solid #e0ddf5;
  border-radius: 6px;
  cursor: pointer;
}

.fa-picker__item:hover,
.fa-picker__item:focus-visible {
  border-color: #7367f0;
  color: #7367f0;
}

.fa-picker__item--active {
  background: #7367f0;
  border-color: #7367f0;
  color: #fff;
}
</style>
